module.exports = __webpack_public_path__ + "files/70837a30c4831208f720dc37cc943559.woff";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/pt_sans-web-italic-webfont.woff
// module id = 903
// module chunks = 60